/*
  Article index: jump links to every H2, plus the FAQ.  (Igor 2026-09-13)

  "first an index section with links pushing to certain parts on the article
   linking to H2's" and "(FAQ should be also in the index at the top of the
   article)".

  WHY JS AND NOT LIQUID. The H2s live inside `article.content`, which is
  store-owned HTML written in the Shopify editor. It carries no ids, and Liquid
  has no HTML parser, so there is no way to enumerate those headings at render
  time. This walks the rendered body instead, which is also the only thing that
  reflects what an editor actually published.

  The nav ships with `hidden` on it and is only revealed once there is something
  to list, so an article with no H2s shows nothing rather than an empty box.
*/
(function () {
  'use strict';

  function slug(text, used) {
    var base = text
      .toLowerCase()
      .replace(/[^a-z0-9à-ÿ\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .slice(0, 60) || 'sectie';
    var id = base, n = 2;
    while (used[id]) { id = base + '-' + n; n++; }
    used[id] = true;
    return id;
  }

  function build() {
    var nav = document.querySelector('[data-hm-article-index]');
    if (!nav) return;

    var list = nav.querySelector('ol');
    var body = document.querySelector('.article-template__content');
    if (!list || !body) return;

    var used = {};
    var entries = [];

    Array.prototype.forEach.call(body.querySelectorAll('h2'), function (h) {
      var text = (h.textContent || '').trim();
      if (!text) return;
      if (!h.id) h.id = slug(text, used);
      entries.push({ id: h.id, text: text });
    });

    // The FAQ is its own section further down the page, so it is not in the
    // article body and has to be picked up separately.
    var faqSection = document.querySelector('[id*="article-faq"]');
    if (faqSection) {
      var faqHeading = faqSection.querySelector('h2');
      if (faqHeading) {
        var t = (faqHeading.textContent || '').trim();
        if (t) {
          if (!faqHeading.id) faqHeading.id = slug(t, used);
          entries.push({ id: faqHeading.id, text: t });
        }
      }
    }

    if (entries.length < 2) return;   // one link is not an index

    entries.forEach(function (e) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + e.id;
      a.textContent = e.text;
      li.appendChild(a);
      list.appendChild(li);
    });

    nav.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
